function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#0272b6",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22 2h-2.13l-6.69 7.79L7.82 2H2l7.95 11.56L2.69 22h2.17l6.05-7.04 4.81 7h5.82l-7.4-10.77L22 2.04V2zm-3.31 18.46h-2.18l-4.59-6.68-.96-1.4L4.85 3.5h2.18l5.14 7.47.96 1.4 5.56 8.09z"
}));